// NPM
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Actions, Services, Selectors
import { isActionInProgress } from 'selectors';
import { REGISTER_USER, SEND_EXTERNAL_AUTH_TOKEN } from 'actionTypes';
import * as actions from 'actions';
import { passwordConfirmationValidation } from 'services/validationHelpers';

// Components
import Form from 'Components/Form';
import OAuthButtons from 'Components/Auth/OAuthButtons';
import AuthModalNavButton from './AuthModalNavButton';

import { Text, Modal } from 'frontend-component-library';

import { FORM_KEYS } from 'Components/Auth/AuthModal';

export const REGISTRATION_KEY = 'register';

class RegistrationForm extends Component {
  handleSubmit = userData => {
    this.props.registerUser(userData);
  };

  render() {
    const { errors, closeModal, updateModal } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2 className="AuthModalHeader">Register</h2>
          <div className="AuthModal-header-links">
            <AuthModalNavButton
              updateModal={updateModal}
              formToDisplay={FORM_KEYS.login}
              text="Log In"
            />
          </div>
        </Modal.Header>
        <Modal.Section>
          <Form
            onSubmit={this.handleSubmit}
            disabled={this.props.isFetching}
            errors={errors}
            className="AuthForm"
          >
            <Text
              name="first_name"
              text="First Name"
              placeholder="First Name..."
              type="text"
              required
            />
            <Text
              name="last_name"
              text="Last Name"
              placeholder="Last Name..."
              type="text"
              required
            />
            <Text
              name="email"
              text="Email"
              placeholder="Enter your email..."
              type="email"
              required
            />
            <Text
              name="password"
              text="Password"
              placeholder="Enter your password..."
              type="password"
              required
            />
            <Text
              name="password_confirmation"
              text="Password Confirmation"
              placeholder="Enter your password..."
              type="password"
              required
              validationCallback={passwordConfirmationValidation}
            />
          </Form>
        </Modal.Section>
        <Modal.Section>
          <OAuthButtons authType="register" />
        </Modal.Section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFetching: isActionInProgress(state, REGISTER_USER),
    errors: {
      ...state.endpointErrors[REGISTER_USER],
      ...state.endpointErrors[SEND_EXTERNAL_AUTH_TOKEN],
    },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      registerUser: actions.registerUser,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/RegistrationForm.js